import React from 'react';
import styled from 'styled-components';

const F1Style = styled.svg``;

export const F1 = ({ color }) => {
	return (
		<F1Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.251'
			height='22.258'
			viewBox='0 0 22.251 22.258'
		>
			<path
				id='Sun'
				d='M882.046,382.007a6.214,6.214,0,1,1-4.386,1.822,6.2,6.2,0,0,1,4.386-1.822Zm-4.885.11h0l-1.762-1.775a.872.872,0,0,0-1.215,0,.861.861,0,0,0,0,1.216l1.767,1.774a.867.867,0,0,0,1.21,0,.849.849,0,0,0,0-1.215Zm-2.88,5.237h0a.856.856,0,0,1,.851.863.844.844,0,0,1-.851.85h-2.5a.845.845,0,0,1-.851-.85.857.857,0,0,1,.851-.863Zm1.666,5.748h0l-1.762,1.774a.857.857,0,0,0,1.215,1.21l1.762-1.768a.863.863,0,0,0,0-1.216.872.872,0,0,0-1.215,0Zm5.249,2.886h0a.854.854,0,1,1,1.708,0v2.5a.854.854,0,1,1-1.708,0v-2.5Zm5.748-1.67h0l1.762,1.768a.858.858,0,0,0,1.216-1.21l-1.768-1.774a.867.867,0,0,0-1.21,0,.852.852,0,0,0,0,1.216Zm2.88-5.251h0a.854.854,0,0,1-.862-.85.866.866,0,0,1,.862-.863h2.5a.86.86,0,0,1,.851.863.848.848,0,0,1-.851.85Zm-1.676-5.735h0l1.774-1.774a.858.858,0,1,0-1.21-1.216l-1.774,1.78a.856.856,0,0,0,0,1.21.866.866,0,0,0,1.21,0Zm-5.244-2.88h0a.854.854,0,0,1-1.708,0v-2.509a.854.854,0,1,1,1.708,0v2.509Zm2.328,4.581h0a4.5,4.5,0,0,0-6.356,6.368,4.5,4.5,0,0,0,6.356-6.368Z'
				transform='translate(-870.926 -377.086)'
				fill={color}
			/>
		</F1Style>
	);
};
